<!--suppress AngularNgOptimizedImage -->
<div class="addContainer" data-tour="gemp-modal">
  <div class="modalHeader">
    <div class="editRowModal">
      <div class="modalHeader clearfix">
        <div class="modal-about">
          {{ dialogTitle }}
        </div>
      </div>
    </div>
    <button (click)="dialogRef.close()" aria-label="Close dialog" class="modal-close-button" mat-icon-button data-tour="gemp-modal-close">
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <div mat-dialog-content>
    <form (ngSubmit)="confirmAdd()" [formGroup]="groupsForm" class="responsive-form">
    <!-- Campo Nombre -->
      <div class="row">
        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 mb-4">
          <mat-form-field appearance="outline" class="example-full-width">
            <mat-label>NOMBRE</mat-label>
            <input
              data-tour="gemp-input-nombre"
              aria-autocomplete="none"
              autocomplete="nope"
              formControlName="nombre"
              matInput required>
            <mat-icon class="material-icons-outlined color-icon p-3" matSuffix>business_group</mat-icon>
          </mat-form-field>
          <div *ngIf="groupsForm.get('nombre')?.touched && groupsForm.get('nombre')?.invalid"
               class="custom-error-below">
            <small *ngIf="groupsForm.get('nombre')?.hasError('required')" class="text-danger">
              NOMBRE OBLIGATORIO.
            </small>
            <small *ngIf="groupsForm.get('nombre')?.hasError('pattern')" class="text-danger">
              SOLO LETRAS Y ESPACIOS.
            </small>
          </div>
        </div>
      </div>

      <!-- Campo Abreviatura -->
      <div class="row">
        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 mb-4">
          <mat-form-field appearance="outline" class="example-full-width">
            <mat-label>ABREVIATURA</mat-label>
            <input
              data-tour="gemp-input-abreviatura"
              aria-autocomplete="none"
              autocomplete="nope"
              formControlName="abreviatura"
              matInput
              maxlength="3" required>
            <mat-icon class="material-icons-outlined color-icon p-3" matSuffix>business_group</mat-icon>
          </mat-form-field>
          <div *ngIf="groupsForm.get('abreviatura')?.touched && groupsForm.get('abreviatura')?.invalid"
               class="custom-error-below">
            <small *ngIf="groupsForm.get('abreviatura')?.hasError('required')" class="text-danger">
              ABREVIATURA OBLIGATORIA.
            </small>
            <small *ngIf="groupsForm.get('abreviatura')?.hasError('pattern')" class="text-danger">
              SOLO LETRAS.
            </small>
            <small *ngIf="groupsForm.get('abreviatura')?.hasError('maxlength')" class="text-danger">
              MAXIMO 3 CARACTERES.
            </small>
          </div>
        </div>
      </div>

      <!-- Campo Logo -->
      <div class="row">
        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12">
          <div class="card">
            <div class="header">
              <h2>LOGO</h2>
            </div>
            <div class="body">
              <div class="example-container">
                <form [formGroup]="groupsForm">
                  <div class="row">
                    <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 mb-5">
                      <label>{{ action === 'edit' ? 'REEMPLAZAR' : 'SUBIR' }}</label>
                      <app-file-upload
                        data-tour="gemp-input-logo"
                        formControlName="logoBase64"
                        [acceptedTypes]="'image/*'"
                        [emitBase64Only]="true"
                        [externalSrc]="(action === 'edit' && gemp.logoBase64) ? ('data:image/jpeg;base64,' + gemp.logoBase64) : null">
                      </app-file-upload>
                    </div>
                  </div>
                </form>
              </div>
              <mat-error *ngIf="groupsForm.get('logoBase64')?.hasError('required')">
                LOGO OBLIGATORIO Y EN FORMATO PNG.
              </mat-error>
            </div>
          </div>
        </div>
      </div>
      <!-- Botones de accion -->
      <div class="row">
        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 mb-2">
          <div class="example-button-row">
            <button (click)="confirmAdd()" [disabled]="!groupsForm.valid" [mat-dialog-close]="1" color="primary"
                    mat-flat-button data-tour="gemp-btn-guardar">
              GUARDAR
            </button>
            <button (click)="onNoClick()" color="warn" mat-flat-button tabindex="-1">
              CANCELAR
            </button>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>
